import TransactionOccurrenceDetails from "../../../../_utils/TransactionCommonComponents/TransactionOccurrenceDetails";

const ScheduleTransactionStepFrequency = ({
  txnPayLoad,
  setTxnPayLoad,
  setIsOccurrencesModalOpen,
  SlotMappingData,
  frequencyOptions,
  frequencyStartDate,
  frequencyEndDate,
  setFrequencyStartDate,
  setFrequencyEndDate,
  showDatePicker,
  setShowDatePicker,
  showEndDatePicker,
  setShowEndDatePicker,
  dropdownOpen,
  setDropdownOpen,
  slotdropdownOpen,
  setSlotDropdownOpen,
  dateRef,
  endDateRef,
  yearDropdownRef,
  formatDate,
  handleDateChange,
  handleEndDateChange,
  handleConfirm,
  handleCancel,
  handleEndConfirm,
  handleEndCancel,
  getEndDate,
  weekdays,
  months,
}) => {
  return (
    <>
      <div className="w-width-full flex lg:flex-row flex-col py-padding-md lg:mb-margin-base mb-margin-xxl lg:px-padding-base px-padding-md">
        <div className="relative z-z-index-content w-width-full">
          <TransactionOccurrenceDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            SlotMappingData={SlotMappingData}
            frequencyOptions={frequencyOptions}
            startDate={frequencyStartDate}
            endDate={frequencyEndDate}
            setStartDate={setFrequencyStartDate}
            setEndDate={setFrequencyEndDate}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            showEndDatePicker={showEndDatePicker}
            setShowEndDatePicker={setShowEndDatePicker}
            dropdownOpen={dropdownOpen}
            setDropdownOpen={setDropdownOpen}
            slotdropdownOpen={slotdropdownOpen}
            setSlotDropdownOpen={setSlotDropdownOpen}
            dateRef={dateRef}
            endDateRef={endDateRef}
            yearDropdownRef={yearDropdownRef}
            formatDate={formatDate}
            handleDateChange={handleDateChange}
            handleEndDateChange={handleEndDateChange}
            handleConfirm={handleConfirm}
            handleCancel={handleCancel}
            handleEndConfirm={handleEndConfirm}
            handleEndCancel={handleEndCancel}
            getEndDate={getEndDate}
            weekdays={weekdays}
            months={months}
            setOpenOccurrencesModal={setIsOccurrencesModalOpen}
          />
        </div>
        <div className="h-mobile-create-header w-width-full Qmd:hidden block mb-margin-xl lg:mb-margin-base" />
      </div>
    </>
  );
};

export default ScheduleTransactionStepFrequency;
